import React from 'react';
import { Badge as BootstrapBadge } from 'react-bootstrap';
import style from './style.module.scss';

export const Badge: React.FC = (props) => (
  <div className={style.badge}><BootstrapBadge>{props.children}</BootstrapBadge></div>
);
